import { FormattedMessage as FM } from "react-intl";

import { cn } from "tools/ui";

const tabBase =
  "flex shrink-0 items-center gap-2 whitespace-nowrap rounded-t-md border-b-2 px-4 py-3 text-sm font-medium transition-colors";
const tabActive = "border-sky-900 text-sky-950 bg-white";
const tabIdle =
  "border-transparent text-neutral-500 hover:text-neutral-800 hover:border-neutral-300";

function MelhousTabs({ tabs, current, onChange }) {
  return (
    <nav className="w-full overflow-x-auto border-b border-neutral-200">
      <div className="flex min-w-max gap-1 px-3 lg:px-4">
        {tabs.map(({ id, label, Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            className={cn(tabBase, current === id ? tabActive : tabIdle)}
          >
            <Icon width={18} className="fill-current" />
            <FM id={label} />
          </button>
        ))}
      </div>
    </nav>
  );
}

export default MelhousTabs;
